// extracted by mini-css-extract-plugin
export default {"wayfinderWidget":"styles_wayfinderWidget__zeXwc","link":"styles_link__hnleD"};